import "../RaikoCustomChip.scss"
import PropTypes from "prop-types";
import {RaikoChipTypes} from "../RaikoChipTypes";

export const RaikoCustomSimpleChip = ({title, type = RaikoChipTypes.info, className}) => {
    return (
        <section className={`raikoCustomChipBaseContainer ${className}`}>
            <div className={`raikoCustomChipContainer ${type}`}>
                <span className={"customChipTitle"}>{title}</span>
            </div>
        </section>
    )
}

RaikoCustomSimpleChip.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string
}





